/* eslint-disable */
import React, { useState, useEffect } from "react";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Image from "react-bootstrap/Image";
import { serverTimestamp } from "firebase/firestore";
import DataTableTemplatingDemoSettings from "../../components/products/DataTableTemplatingDemo/DataTableTemplatingDemoSettings";
import { Search, PlusCircle, Filter, Sliders } from "lucide-react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

function Stock() {
  const MySwal = withReactContent(Swal);
  const [showSideBar, setShowSideBar] = useState(true);
  const products = useSelector((state) => state.ProductsReducer);
  const store = useSelector((state) => state.StoreReducer);
  const categories = store.categories;
  const { t, i18n } = useTranslation();
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClick = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const [lgShow, setLgShow] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [images, setImages] = useState([
    {
      original: "https://picsum.photos/id/1018/1000/600/",
      thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
      original: "https://picsum.photos/id/1015/1000/600/",
      thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
      original: "https://picsum.photos/id/1019/1000/600/",
      thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
  ]);
  const [filter, setFilter] = useState("");
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showDisplaySettings, setShowDisplaySettings] = useState(false);
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [stockStatus, setStockStatus] = useState("all");
  const [hasAdvancedFilters, setHasAdvancedFilters] = useState(false);
  const [sortBy, setSortBy] = useState("newest");
  const [displayColumns, setDisplayColumns] = useState({
    image: true,
    name: true,
    sku: true,
    quantity: true,
    price: true,
    visits: true,
  });

  // Function to apply all filters to the products data
  const applyFilters = (products) => {
    if (!products) return [];

    return products
      .filter((product) => {
        if (hasAdvancedFilters) {
          // Category filter
          if (
            categoryFilter !== "all" &&
            product.category_id !== categoryFilter
          ) {
            return false;
          }

          // Price range filter
          const price = parseFloat(product.price);
          if (!isNaN(price) && (price < priceRange[0] || price > priceRange[1])) {
            return false;
          }

          // Stock status filter
          if (stockStatus !== "all") {
            const qty = parseInt(product.qty);
            if (stockStatus === "in-stock" && (!qty || qty <= 0)) {
              return false;
            } else if (
              stockStatus === "low-stock" &&
              (!qty || qty > 10 || qty <= 0)
            ) {
              return false;
            } else if (stockStatus === "out-of-stock" && qty > 0) {
              return false;
            }
          }
        }

        // Text search filter
        if (filter && filter.trim() !== "") {
          const searchTerm = filter.toLowerCase();
          const name = (product.name || "").toLowerCase();
          const sku = (product.sku || "").toLowerCase();

          if (!name.includes(searchTerm) && !sku.includes(searchTerm)) {
            return false;
          }
        }

        return true;
      })
      .sort((a, b) => {
        // Apply sorting
        switch (sortBy) {
          case "newest":
            return (b.timeStamp?.seconds || 0) - (a.timeStamp?.seconds || 0);
          case "oldest":
            return (a.timeStamp?.seconds || 0) - (b.timeStamp?.seconds || 0);
          case "price-high":
            return parseFloat(b.price || 0) - parseFloat(a.price || 0);
          case "price-low":
            return parseFloat(a.price || 0) - parseFloat(b.price || 0);
          case "name-asc":
            return (a.name || "").localeCompare(b.name || "");
          case "name-desc":
            return (b.name || "").localeCompare(a.name || "");
          default:
            return 0;
        }
      });
  };

  const [data, setData] = useState({
    name: "",
    image: "",
    review: "",
    price: "",
    oldPrice: "",
    comment: "",
    qty: "",
    category_id: "",
    sku: "",
    show: "1",
    short: "",
    options: [
      {
        title: "1",
        color: "1",
        colorOption: [
          {
            option: "",
            color: "",
          },
        ],
      },
    ],
    discount: {
      freeDelivery: true,
      discountDelivery: 0,
      discountTotal: 0,
    },
    offers: [
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
    ],
    gallery: [],
    textEditor: "<p><br></p>",
    timeStamp: serverTimestamp(),
  });
  const isRTL = i18n.language === 'ar';
  return (
    <div className="container-fluid bg-purple-50 dark:bg-[#141414] min-h-screen" dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#141414]" 
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] flex flex-col gap-y-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-0">
                  {t("Stock.title")}
                </h2>
                <p className="text-gray-600 dark:text-gray-400mb-0">
                  {t("Stock.description")}
                </p>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="relative flex-grow max-w-xl">
                <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                  <Search size={16} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  className="bg-gray-50 dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] text-gray-900  text-sm rounded-lg block w-full pr-10 p-2.5  focus:outline-none focus:ring-2 focus:ring-purple-200"
                  placeholder={t("Stock.searchPlaceholder")}
                  value={filter}
                  onChange={(e) => setFilter(e.target.value)}
                />
              </div>
              <div className="flex items-center gap-2">
                <button
                  className="bg-gray-100 dark:!bg-[#9b59bf] hover:bg-gray-200 px-3 py-2 rounded-lg shadow-sm transition-colors flex items-center gap-2 text-gray-700 dark:text-white text-sm"
                  onClick={() => setShowFilterModal(true)}
                >
                  <Filter size={16} />
                  <span>{t("Stock.filterButton")}</span>
                </button>
                <button
                  className="bg-gray-100 dark:!bg-[#9b59bf] hover:bg-gray-200 px-3 py-2 rounded-lg shadow-sm transition-colors flex items-center gap-2 text-gray-700 dark:text-white text-sm"
                  onClick={() => setShowDisplaySettings(true)}
                >
                  <Sliders size={16} />
                  <span>{t("Stock.displaySettingsButton")}</span>
                </button>
              </div>

              {/* Filter Modal */}
              {showFilterModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white rounded-lg shadow-xl border border-[#fbf4ff] p-6 max-w-md w-full mx-4">
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="font-bold text-lg text-[#9e68ba]">
                        {t("Stock.filterModal.title")}
                      </h4>
                      <button
                        className="text-gray-500 hover:text-gray-700 text-xl"
                        onClick={() => setShowFilterModal(false)}
                      >
                        &times;
                      </button>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t("Stock.filterModal.categoryLabel")}
                      </label>
                      <select
                        className="w-full p-2.5 border border-gray-200 rounded-lg"
                        value={categoryFilter}
                        onChange={(e) => setCategoryFilter(e.target.value)}
                      >
                        <option value="all">{t("Stock.filterModal.categoryOptions.all")}</option>
                        {categories
                          ?.filter((item) => typeof item === "string" && !item.startsWith("http"))
                          .map((category, index) => (
                            <option key={index} value={category}>
                              {category}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t("Stock.filterModal.priceLabel")}
                      </label>
                      <div className="flex items-center gap-3">
                        <input
                          type="number"
                          className="w-full p-2.5 border border-gray-200 rounded-lg"
                          placeholder={t("Stock.filterModal.priceFrom")}
                          value={priceRange[0]}
                          onChange={(e) =>
                            setPriceRange([
                              parseInt(e.target.value),
                              priceRange[1],
                            ])
                          }
                        />
                        <span>-</span>
                        <input
                          type="number"
                          className="w-full p-2.5 border border-gray-200 rounded-lg"
                          placeholder={t("Stock.filterModal.priceTo")}
                          value={priceRange[1]}
                          onChange={(e) =>
                            setPriceRange([
                              priceRange[0],
                              parseInt(e.target.value),
                            ])
                          }
                        />
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-700 mb-2">
                        {t("Stock.filterModal.stockStatusLabel")}
                      </label>
                      <select
                        className="w-full p-2.5 border border-gray-200 rounded-lg"
                        value={stockStatus}
                        onChange={(e) => setStockStatus(e.target.value)}
                      >
                        <option value="all">{t("Stock.filterModal.stockStatusOptions.all")}</option>
                        <option value="in-stock">{t("Stock.filterModal.stockStatusOptions.in-stock")}</option>
                        <option value="low-stock"> {t("Stock.filterModal.stockStatusOptions.low-stock")}</option>
                        <option value="out-of-stock"> {t("Stock.filterModal.stockStatusOptions.out-of-stock")}</option>
                      </select>
                    </div>

                    <div className="flex justify-between gap-3">
                      <button
                        className="bg-gray-200 hover:bg-gray-300 text-gray-700 px-4 py-2.5 rounded-lg font-medium flex-1 transition-colors"
                        onClick={() => {
                          setCategoryFilter("all");
                          setPriceRange([0, 5000]);
                          setStockStatus("all");
                          setSortBy("newest");
                          setHasAdvancedFilters(false);
                        }}
                      >
                        {t("Stock.filterModal.reset")}
                      </button>
                      <button
                        className="bg-[#9b59bf] hover:bg-[#814a9f] text-white px-4 py-2.5 rounded-lg font-medium flex-1 transition-colors"
                        onClick={() => {
                          // Apply filters and close modal
                          setHasAdvancedFilters(true);
                          setShowFilterModal(false);

                          // For demonstration, show a confirmation message
                          Swal.fire({
                            icon: "success",
                            title: t("Stock.filterModal.successMessage"),
                            text: t("Stock.filterModal.successText", { min: priceRange[0], max: priceRange[1] }),
                            confirmButtonText: t("Stock.filterModal.confirmButton"),
                            confirmButtonColor: "#8b5cf6",
                          });
                        }}
                      >
                        {t("Stock.filterModal.apply")}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Display Settings Modal */}
              {showDisplaySettings && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                  <div className="bg-white  rounded-lg shadow-xl border border-[#fbf4ff] p-6 max-w-md w-full mx-4">
                    <div className="flex justify-between items-center mb-4">
                      <h4 className="font-bold text-lg text-[#9e68ba]">
                        {t("Stock.displaySettingsModal.title")}
                      </h4>
                      <button
                        className="text-gray-500 hover:text-gray-700 text-xl"
                        onClick={() => setShowDisplaySettings(false)}
                      >
                        &times;
                      </button>
                    </div>

                    <div className="mb-6">
                      <p className="text-sm font-medium text-gray-700 mb-3">
                        {t("Stock.displaySettingsModal.columnsTitle")}
                      </p>

                      <div className="space-y-3">
                        <label className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={displayColumns.image}
                            onChange={() =>
                              setDisplayColumns({
                                ...displayColumns,
                                image: !displayColumns.image,
                              })
                            }
                            className="rounded text-[#9e68ba] w-4 h-4"
                          />
                          {t("Stock.displaySettingsModal.columns.image")}
                        </label>

                        <label className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={displayColumns.name}
                            onChange={() =>
                              setDisplayColumns({
                                ...displayColumns,
                                name: !displayColumns.name,
                              })
                            }
                            className="rounded text-[#9e68ba] w-4 h-4"
                          />
                          {t("Stock.displaySettingsModal.columns.name")}
                        </label>

                        <label className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={displayColumns.sku}
                            onChange={() =>
                              setDisplayColumns({
                                ...displayColumns,
                                sku: !displayColumns.sku,
                              })
                            }
                            className="rounded text-[#9e68ba] w-4 h-4"
                          />
                          {t("Stock.displaySettingsModal.columns.sku")}
                        </label>

                        <label className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={displayColumns.quantity}
                            onChange={() =>
                              setDisplayColumns({
                                ...displayColumns,
                                quantity: !displayColumns.quantity,
                              })
                            }
                            className="rounded text-[#9e68ba] w-4 h-4"
                          />
                          {t("Stock.displaySettingsModal.columns.quantity")}
                        </label>

                        <label className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={displayColumns.price}
                            onChange={() =>
                              setDisplayColumns({
                                ...displayColumns,
                                price: !displayColumns.price,
                              })
                            }
                            className="rounded text-[#9e68ba] w-4 h-4"
                          />
                          {t("Stock.displaySettingsModal.columns.price")}
                        </label>

                        <label className="flex items-center gap-2 text-sm">
                          <input
                            type="checkbox"
                            checked={displayColumns.visits}
                            onChange={() =>
                              setDisplayColumns({
                                ...displayColumns,
                                visits: !displayColumns.visits,
                              })
                            }
                            className="rounded text-[#9e68ba] w-4 h-4"
                          />
                          {t("Stock.displaySettingsModal.columns.visits")}
                        </label>
                      </div>
                    </div>

                    <button
                      className="w-full bg-[#9b59bf] hover:bg-[#814a9f] text-white px-4 py-2.5 rounded-lg font-medium transition-colors"
                      onClick={() => {
                        setShowDisplaySettings(false);

                        // For demonstration, show a confirmation message
                        Swal.fire({
                          icon: "success",
                          title: t("Stock.displaySettingsModal.successMessage"),
                          text: t("Stock.displaySettingsModal.successText"),
                          confirmButtonText: t("Stock.displaySettingsModal.confirmButton"),
                          confirmButtonColor: "#8b5cf6",
                        });
                      }}
                    >
                      {t("Stock.displaySettingsModal.saveButton")}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Main Content */}
          <div className="px-3">
            <DataTableTemplatingDemoSettings
              lgShow={lgShow}
              setLgShow={setLgShow}
              modelShow={modelShow}
              setModelShow={setModelShow}
              setImages={setImages}
              data={data}
              setData={setData}
              products={applyFilters(products)}
              displayColumns={displayColumns}
              filter={filter}
            />
          </div>

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Stock;
